var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClosePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3594,
    y: 10.8809,
    width: 24.4444,
    height: 2.22222,
    transform: "rotate(45 11.3594 10.8809)",
    fill: "#2E3441"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6426,
    y: 12.4521,
    width: 24.4444,
    height: 2.22222,
    transform: "rotate(135 28.6426 12.4521)",
    fill: "#2E3441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosePopup);
export default __webpack_public_path__ + "static/media/icon_close_popup.6a7b68275ffba18005ca9c9ec74c5e31.svg";
export { ForwardRef as ReactComponent };